/**
 * Angular 2
 */
import {
  enableDebugTools,
  disableDebugTools
} from '@angular/platform-browser';
import {
  ApplicationRef,
  enableProdMode
} from '@angular/core';
import {CoolLocalStorage} from "../../node_modules/angular2-cool-storage/src/cool-local-storage";
import {ToastyService} from "../../node_modules/ng2-toasty/src/toasty.service";
/**
 * Environment Providers
 */
let PROVIDERS:any[] = [
  CoolLocalStorage,
  ToastyService
/**
 * Common env directives
 */
];

/**
 * Angular debug tools in the dev console
 * https://github.com/angular/angular/blob/86405345b781a9dc2438c0fbe3e9409245647019/TOOLS_JS.md
 */
let _decorateModuleRef = <T>(value:T):T => {
  return value;
};

if ('production' === ENV) {
  enableProdMode();

  /**
   * Production
   */
  _decorateModuleRef = (modRef:any) => {
    disableDebugTools();

    return modRef;
  };

  PROVIDERS = [
    ...PROVIDERS,
  /**
   * Custom providers in production.
   */
  ];

} else {

  _decorateModuleRef = (modRef:any) => {
    const appRef = modRef.injector.get(ApplicationRef);
    const cmpRef = appRef.components[0];

    enableDebugTools(cmpRef);
    return modRef;
  };

  /**
   * Development
   */
  PROVIDERS = [
    ...PROVIDERS,
  /**
   * Custom providers in development.
   */
  ];

}

export const decorateModuleRef = _decorateModuleRef;

export const ENV_PROVIDERS = [
  ...PROVIDERS
];



// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/environment.ts